import React, { Component } from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  MsalContext,
} from "@azure/msal-react";

import runtimeEnv from "@mars/heroku-js-runtime-env";

//Import CSS Styles
import "./App.scss";

import "bootstrap/dist/css/bootstrap.min.css";

//Import components
import Login from "../Login/Login";
import Dashboard from "../Dashboard/Dashboard";
import SingleSingOn from "../Dashboard/templates/Products/SingleSignOn/SingleSingOn";
import fetchAPI from "../../components/utils/fetchAPI";
import fetchAuth from "../../components/utils/fetchAuth";

const env = runtimeEnv();

export default class App extends Component {
  static contextType = MsalContext;
  state = {
    appName: "Honey Load",
    authenticated: false,
    userData: {},
    countryCode: "",
    flagFetchAppi: false,
    pruebaPaises: "",
    originalUserCodeCountry: null,
  };

  componentDidMount() {
    this.setState({
      originalUserCodeCountry: localStorage.getItem("codeCountry"),
    });
  }

  fetchNewUser = () => {
    window.hmnr = env
    this.setState({ flagFetchAppi: true });
    let contextAcount = this.context.accounts[0];
    localStorage.setItem("clientId", contextAcount.idTokenClaims.oid);
    if (
      env.REACT_APP_NODE_ENV === "development" &&
      env.REACT_APP_SERVICES_COUNTRY_DEFAULT
    ) {
      contextAcount.idTokenClaims.ctry = env.REACT_APP_SERVICES_COUNTRY_DEFAULT;
    }
    var countryCode;

    var countryName;
    switch (contextAcount?.idTokenClaims?.ctry) {
      case "MX":
        countryCode = "mdmexico";
        countryName = "Mexico";
        break;
      case "CO":
        countryCode = "mdcolombia";
        countryName = "Colombia";
        break;
      case "PE":
        countryCode = "mdperu";
        countryName = "Peru";
        break;
      case "EC":
        countryCode = "mdecuador";
        countryName = "Ecuador";
        break;

      default:
        // countryCode = 'mdcolombia';
        // countryName = 'Colombia'
        break;
    }
    localStorage.setItem("originalCodeContry", countryCode);

    if (this.state.originalUserCodeCountry) {
      countryCode = this.state.originalUserCodeCountry;
    }

    this.setState({ countryCode: countryCode });

    let params = {
      clientId: contextAcount?.idTokenClaims.oid,
      clientName: contextAcount?.idTokenClaims.name,
      clientEmail: contextAcount?.idTokenClaims.preferred_username,
      country: countryCode === "mdcolombia" ? "Colombia" : countryName,
    };
    if (this.state.originalUserCodeCountry) {
      fetchAuth({
        clientId: contextAcount?.idTokenClaims.oid,
        countrysCode: countryCode,
      }).then((response) => {
        try {
          let record = response;
          if (this.state.originalUserCodeCountry) {
            record.user = response.data;
          }
          return this.setState({
            userData: record,
          });
        } catch (error) {
          console.log(error);
        }
      });
    } else {
      fetchAPI({
        service: env.REACT_APP_SERVICES_GET_ALL_USERS + `/${countryCode}`,
        protocol: "POST",
        params: params,
        verifyAuth: false,
        codeCountry: countryCode,
        callbackThen: (response) => {
          try {
            let record = response;
            return this.setState({
              userData: record,
            });
          } catch (error) {
            console.log(error);
          }
        },
      });
    }
  };

  selectedCountry = (e) => {
    console.log("country en app ", e);
    // if(e){
    //   return this.setState({countryCode: e})
    // }
  };

  render() {
    if (this.context.accounts[0] && this.state.flagFetchAppi === false) {
      this.fetchNewUser();
    }
    if (this.state.userData?.user?.clientName && this.state?.countryCode) {
      //Fixes issue generated by Chrome and Edge when eliminating a Node updating a state:
      if (typeof Node === "function" && Node.prototype) {
        const originalRemoveChild = Node.prototype.removeChild;
        Node.prototype.removeChild = function (child) {
          if (child.parentNode !== this) {
            if (console) {
              console.warn(
                "Cannot remove a child from a different parent",
                child,
                this
              );
            }
            return child;
          }
          return originalRemoveChild.apply(this, arguments);
        };

        const originalInsertBefore = Node.prototype.insertBefore;
        Node.prototype.insertBefore = function (newNode, referenceNode) {
          if (referenceNode && referenceNode.parentNode !== this) {
            if (console) {
              console.warn(
                "Cannot insert before a reference node from a different parent",
                referenceNode,
                this
              );
            }
            return newNode;
          }
          return originalInsertBefore.apply(this, arguments);
        };
      }

      // if(this.context.accounts[0]){
      //   this.fetchNewUser();
      // }
      return (
        <>
          <AuthenticatedTemplate>
            <Dashboard
              userData={this.state.userData}
              country={
                this.context.accounts[0].idTokenClaims.ctry === "MX"
                  ? "Mexico"
                  : "Colombia"
              }
              countriesCode={this.state.countryCode}
              selectedCountry={(e) => this.selectedCountry(e)}
            />
            {/* <SingleSingOn /> */}
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <Login />
          </UnauthenticatedTemplate>
        </>
      );
    }
    return (
      <>
        <UnauthenticatedTemplate>
          <Login />
        </UnauthenticatedTemplate>
      </>
    );
  }
}
